import { Maybe } from '@gql/schema';

export enum FlightsSelectOption {
  hotelOnly = 'hotelOnly',
  hotelWithFlights = 'hotelWithFlights',
}

export interface IFlightPrice {
  available?: boolean;
  departureAirportName?: Maybe<string>;
  duration?: Maybe<number>;
  numOfPeople?: number;
  price?: Maybe<string>;
  unitLabel?: string;
  tooltip?: string;
}

export interface IDepartureAirport {
  departureAirportCode: string;
  departureAirportName: string;
  departureAirportCityName: string;
  priceForDisplay: string;
}

export interface IDuration {
  duration: number | null;
  priceForDisplay: number;
}

export interface ISelectOption {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  id: any;
  title: string;
  price: string;
}

export interface ICapacity {
  adults: number;
  children: number;
  infants: number;
  dependants: number;
  rooms: number;
  isAdultsOnly?: boolean;
}

export interface IOffer {
  priceForDisplay: string;
  offerId: string;
  externalReference: string;
}
